import '../../styles/map-coord.css'

export default function MouseCoord (L, projection, proj4, map) {
    const prj = proj4(projection)
    let _container = null

    const onMouseMove = (e) => {
        const projCoords = prj.forward([e.latlng.lng, e.latlng.lat])
        _container.innerHTML = `${projCoords[0]?.toFixed(2)} | ${projCoords[1]?.toFixed(2)}`;
    }

    const bottomLeft = L.control({
        position: 'bottomleft'
    });

    bottomLeft.onAdd = function (map) {
        _container = L.DomUtil.create('div', 'leaflet-control-coord-projection');
        L.DomEvent.disableClickPropagation(_container);
        map.on('mousemove', onMouseMove, this);
        _container.innerHTML=this.options.emptyString;
        return _container;
    };

    bottomLeft.onRemove = function (map) {
        map.off('mousemove', onMouseMove)
    }

    bottomLeft.addTo(map);

    // L.Map.mergeOptions({
    //     positionControl: false
    // });
    //
    // L.Map.addInitHook(function () {
    //     if (this.options.positionControl) {
    //         this.positionControl = new L.Control.coordProjection();
    //         this.addControl(this.positionControl);
    //     }
    // });
    //
    // L.control.coordProjection = function (options) {
    //     return new L.Control.coordProjection(options);
    // };
}